import { View, Text } from '@react-pdf/renderer';
import theme from '../../../theme';
import { PdfDocumentProps } from './ExportPdf';
import formatNewLines from '../../../lib/helper/format-new-lines';

export type PdfHistoryProps = Pick<PdfDocumentProps, 'auditHistory'>;

const PdfHistory = ({ auditHistory: history }: PdfHistoryProps) => {
    return (
        <>
            {history && (
                <>
                    <View
                        style={{
                            padding: 5,
                            width: '97%',
                            margin: 'auto',
                            borderRadius: '10',
                            fontSize: 15,
                            fontWeight: 'bold'
                        }}>
                        <Text>History</Text>
                    </View>
                    <View
                        style={{
                            padding: 5,
                            border: '2px solid black',
                            borderColor: theme.palette.appBackground.main,
                            width: '97%',
                            margin: 'auto',
                            borderRadius: '10',
                            fontSize: 8
                        }}>
                        <View
                            style={{
                                flexDirection: 'row',
                                borderBottom: '1.5px solid ' + theme.palette.appBackground.main,
                                borderColor: theme.palette.appBackground.main
                            }}>
                            <View style={{ width: '15%', padding: 3 }}>
                                <Text style={{ fontWeight: 'bold' }}>Changed Date</Text>
                            </View>
                            <View style={{ width: '20%', padding: 3 }}>
                                <Text style={{ fontWeight: 'bold' }}>Changed By</Text>
                            </View>
                            <View style={{ width: '15%', padding: 3 }}>
                                <Text style={{ fontWeight: 'bold' }}>Event</Text>
                            </View>
                            <View style={{ width: '50%', padding: 3 }}>
                                <Text style={{ fontWeight: 'bold' }}>Value</Text>
                            </View>
                        </View>
                        {history.length > 0 ? (
                            history.map((item, index) => (
                                <View
                                    key={item.id}
                                    style={{
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        borderBottom:
                                            index !== history.length - 1
                                                ? '1.5px solid ' + theme.palette.appBackground.main
                                                : '0px',
                                        borderColor: theme.palette.appBackground.main
                                    }}
                                    wrap={false}>
                                    <View style={{ width: '15%', padding: 3, fontSize: 7 }}>
                                        <Text>{item.formattedDate}</Text>
                                        <Text>{item.formattedTime}</Text>
                                    </View>
                                    <View style={{ width: '20%', padding: 3 }}>
                                        <Text>{item.changedBy}</Text>
                                    </View>
                                    <View style={{ width: '15%', padding: 3 }}>
                                        <Text>{item.event}</Text>
                                    </View>
                                    <View style={{ width: '50%', padding: 3 }}>
                                        <Text>{formatNewLines(item.value)}</Text>
                                    </View>
                                </View>
                            ))
                        ) : (
                            <View
                                style={{
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    padding: 10
                                }}>
                                <Text>No data</Text>
                            </View>
                        )}
                    </View>
                </>
            )}
        </>
    );
};

export default PdfHistory;
